import store from '@/store';
import RouterSection from '@/Layout/components/RouterSection';
import { getMsgsvcStat } from '@/api/msgsvc/checkMsgsvc';

export default {
	path: '/msgsvc',
	name: 'msgsvc',
	component: RouterSection,
	mode: 'history',
	children: [
		{
			// 로그인 안내
			path: 'loginInfo',
			name: 'loginInfo',
			component: () => import('@/views/msgsvc/sendMng/LoginInfo'),
		},
		{
			// 미가입자 안내
			path: 'unsubscribedInfo',
			name: 'unsubscribedInfo',
			component: () => import('@/views/msgsvc/sendMng/UnsubscribedInfo'),
		},
		{
			// 이용정지 계정 안내
			path: 'suspendedInfo',
			name: 'suspendedInfo',
			component: () => import('@/views/msgsvc/sendMng/SuspendedInfo'),
		},
		{
			// 문자메시지 > 문자메시지 서비스 안내
			path: 'serviceInfo',
			name: 'serviceInfo',
			component: () => import('@/views/msgsvc/ServiceInfo'),
		},
		{
			// 문자메시지 > 발송관리
			path: 'sendMng',
			name: 'sendMng',
			component: () => import('@/views/msgsvc/sendMng/Index'),
			beforeEnter: checkAuthorization,
		},
		{
			// 문자메시지 > 발송관리 > 2차 인증(상세보기, 서브회원 발송한도 탭 이동 전)
			path: 'sendReLogin',
			name: 'sendReLogin',
			component: () => import('@/views/msgsvc/sendMng/ReLogin'),
			beforeEnter: checkAuthorization,
		},
		{
			// 문자메시지 > 발송관리 > 발송내역 탭 > 발송내역 상세보기
			path: 'sendDetail',
			name: 'sendDetail',
			component: () => import('@/views/msgsvc/sendMng/SendDetail'),
			beforeEnter: checkAuthorization,
		},
		{
			// 문자메시지 > 발송관리 > 서브회원 발송한도 탭 > 발송내역 상세보기
			path: 'subSendDetail',
			name: 'subSendDetail',
			component: () => import('@/views/msgsvc/sendMng/SubSendDetail'),
			beforeEnter: checkAuthorization,
		},
	],
};

function checkAuthorization(to, from, next) {
	// 로그아웃 상태일 경우 로그인 페이지로 이동한다.
	if (!store.getters.isLoggedIn) {
		next({ name: 'loginInfo', params: { history: to } });
		return;
	}
	// 문자메시지 서비스 미가입자 및 이용정지 계정일 경우 안내 페이지로 이동한다.
	checkMsgsvc(next);
}

async function checkMsgsvc(next) {
	// 문자메시지 서비스 이용상태 조회
	await getMsgsvcStat({})
		.then(res => {
			if (res.code === 'SUC0000') {
				const resultData = res.result;
				// 미가입자일 경우
				if (resultData.msgsvcUseSttsCd === '00') {
					next({ name: 'unsubscribedInfo' });
					return false;
					// 이용정지 계정일 경우
				} else if (resultData.msgsvcUseSttsCd === '02') {
					next({ name: 'suspendedInfo' });
					return false;
				} else {
					next();
				}
			} else {
				throw new Error(`${res.code}: ${res.message}`);
			}
		})
		.catch(error => {
			throw new Error(`${res.code}: ${res.message}`);
		});
}
